export const USER_FORM_FIELDS = {
    ALL: 'ALL',
    IAM: 'IAM',
    KNOWLEDGE_READ: 'KNOWLEDGE_READ',
    KNOWLEDGE_WRITE: 'KNOWLEDGE_WRITE',
    SETTINGS: 'SETTINGS',
};
